// extracted by mini-css-extract-plugin
export default {"domainName":"cm5RvyrDB","yellowBlock":"cOuL3wMxY","isFree":"ckgdvvHZi","container":"cJ1R_genq","isDisabled":"cex4ANhY5","taken":"cwBNteEIN"};